import React, { Component } from 'react';

export default class ModerationInfiniteScroll extends Component {
    node = React.createRef();
    pending = false;
    mounted = false;
    frame = null;
    componentDidMount() {
        this.mounted = true;
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule);
        this.schedule();
    }
    componentDidUpdate() { this.schedule(); }
    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        window.cancelAnimationFrame(this.frame);
    }
    schedule = () => {
        window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(this.check);
    };
    check = () => {
        const { hasMore, loading, paused, failed, onLoad } = this.props;
        if (!this.mounted || this.pending || !hasMore || loading || paused || failed || !this.node.current) return;
        const bounds = this.node.current.getBoundingClientRect();
        if (bounds.top > window.innerHeight + 240 || bounds.bottom < 0) return;
        this.pending = true;
        Promise.resolve().then(onLoad).finally(() => {
            this.pending = false;
            if (this.mounted) this.schedule();
        });
    };
    render() {
        const { loading, failed, paused, onLoad } = this.props;
        return <div ref={this.node} style={{ minHeight: 32, padding: '8px 20px', textAlign: 'center' }} aria-live="polite">
            {loading && <span role="status">Đang tải...</span>}
            {failed && <button type="button" className="btn btn-link" disabled={loading || paused} onClick={onLoad}>Tải lại</button>}
        </div>;
    }
}
